import $ from 'jquery'
import {
  prepareChessboard,
  validateCoordinates,
  showReminder
} from '../utils'
import User from '../classes/user'
import { CORRECT_ANSWER_AUDIO, WRONG_ANSWER_AUDIO } from '../utils/constants';

/**
* @name highlightCoordinates
* @function
* @param {config}
* @description: chess board related task
*/
export function highlightCoordinates(config) {
  let afterLoad = function () {
    let squares = config.coordinates ? config.coordinates : [],
      coordinateClass = config.coordinateClass,
      next = config.next,
      isQA = config.isQA,
      bubbleConfig = config.bubbleConfig ? config.bubbleConfig : null,
      celebrationSound = (config.celebrationSound === false) ? false : true,
      correctAnswerCount = 0,
      remainingAnswerCount,
      reminder = config.reminder,
      activityCompletionSound = true;
    
    var correctClick = false;

    prepareChessboard(config)

    if (bubbleConfig) {
      bubbleConfig.data = bubbleConfig.data.replace('userName', User.user.name)
    }
    
    var board = document.getElementsByClassName("chessboard-63f37");
    $(board[0]).click(function (e) {
      e.preventDefault();
      if (!correctClick) {
        if (celebrationSound) {
          $(document).trigger('audio-play', WRONG_ANSWER_AUDIO);
        }
      }
      correctClick = false;
    })

    squares.map((k) => {
      return $(k).click(function (e) {
        e.preventDefault();

        if(!$(this).hasClass(coordinateClass)) {
          correctAnswerCount++;
          remainingAnswerCount = squares.length - correctAnswerCount;
          correctClick = true;
          
          if (reminder) {
            showReminder(remainingAnswerCount);
          }
          
          $(this).addClass(coordinateClass);
  
          if (celebrationSound) {
            $(document).trigger('audio-play', CORRECT_ANSWER_AUDIO);
          }
          
          if (isQA) {
            activityCompletionSound = false;
          }

          validateCoordinates(coordinateClass, next, squares.length, bubbleConfig, isQA, activityCompletionSound)
        }
      });
    })
  }
  const chessConfig = {
    config: {
      position: config.position
    },
    afterLoad: afterLoad
  }
  return chessConfig;
}


// WEBPACK FOOTER //
// ./src/lessons/commonActivities.js